import { Dispatch, forwardRef, SetStateAction } from 'react'
import './Input.css'
import { useTranslation } from 'react-i18next'
import { ReactComponent as IcPassed } from '../../../assets/svgs/icon/ic_passed.svg'
import { ReactComponent as IcError } from'../../../assets/svgs/icon/ic_error.svg'

export interface InputInfoMsg {
    msg: string,
    type: "passed" | "error"
}

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    inputVal: string
    setInputVal?: Dispatch<SetStateAction<string>>
    title?: string
    infoMsg?: InputInfoMsg
    isRequired?: boolean
    notShowInfo? : boolean
    containerStyle?: React.CSSProperties
    showClearButton?: boolean
    readOnlyStyle?: boolean
}


export const Input = forwardRef<HTMLInputElement, InputProps>(({
    title,
    infoMsg,
    inputVal,
    setInputVal,
    isRequired,
    notShowInfo,
    containerStyle,
    showClearButton = true,
    readOnlyStyle,
    ...rest
}, ref) => {
    const {t} = useTranslation();

    const handleClear = () => {
        setInputVal?.('')
    }

    return (
        <div style={containerStyle ?? {padding: "10px 0"}}>
            {title &&
                <div className="common-input-title-container">
                    <span className="common-input-title">{title}</span>
                    {isRequired &&
                        <span className="common-input-required">{t("common.required")}</span>
                    }
                </div>
            }
            <div className="common-input-wrapper">
                <input
                    ref={ref}
                    className={`common-input ${readOnlyStyle ? 'read-only' : ''}`}
                    {...rest}
                    value={inputVal}
                    onChange={(e) => {
                        setInputVal && setInputVal(e.target.value)
                        rest.onChange?.(e)
                    }}
                />
                {showClearButton && inputVal && (
                    <button
                        type="button"
                        className="common-input-clear-btn"
                        onClick={handleClear}
                        tabIndex={-1}
                    >
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <circle cx="10" cy="10" r="10" fill="var(--lightGray3)"/>
                            <path d="M6.5 6.5L13.5 13.5M13.5 6.5L6.5 13.5" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
                        </svg>
                    </button>
                )}
            </div>
            {!notShowInfo &&
                <div className="common-input-msg-wrapper">
                    {infoMsg &&
                        <>
                            {infoMsg.type === "error" &&
                                <IcError
                                    height="12px"
                                    width="12px"
                                    color="var(--warning)"
                                />
                            }
                            {infoMsg.type === "passed" &&
                                <IcPassed
                                    height="12px"
                                    width="12px"
                                    color="var(--primary)"
                                />
                            }
                            <span className={`common-input-msg ${infoMsg.type}`}>{infoMsg.msg}</span>
                        </>
                    }
                </div>
            }

        </div>
    )
});